export default __webpack_public_path__ + "static/chd-tv-b91076ef898ead6db8e1e7466ed03af1.svg";